import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChamadoFranquiaEncerrarComponent } from './chamado-franquia-encerrar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: ':id', component: ChamadoFranquiaEncerrarComponent}
  ])],
  exports: [RouterModule]
})
export class ChamadoFranquiaEncerrarRoutingModule { }
